module.exports = __webpack_public_path__ + "img/sdg5_id.0bd6b425.svg";